export class NotificationSenderRoutes
{
    static Home = '/';

    //Topic
    static TopicList = '/topic/list';
    static TopicNew = '/topic/new';
    static TopicCopy(id: string)
    {
        return `/topic/${id}/new`;
    }
    static TopicEdit(id: string)
    {
        return `/topic/${id}/edit`
    }
    static TopicView(id: string)
    {
        return `/topic/${id}/view`;
    }
    //Subscriber
    static SubscriberList = '/subscriber/list';
    static SubscriberNew = '/subscriber/new';
    static SubscriberCopy(id: string)
    {
        return `/subscriber/${id}/new`;
    }
    static SubscriberEdit(id: string)
    {
        return `/subscriber/${id}/edit`;
    }
    static SubscriberView(id: string)
    {
        return `/subscriber/${id}/view`;
    }
    static SubscriberVerify(subscriber_id: string)
    {
        return `/subscriber/${subscriber_id}/verify`;
    }
    static Verify(subscriber_id: string)
    {
        return `/subscriber/${subscriber_id}/verify`;
    };
    static Send(id: string | null)
    {
        let items = ["/subscriber"];
        if (id)
            items.push(`/${id}`);
        items.push(`/send`);
        return items.join("");
    }

    // Sent Topic
    static SentTopicList = '/sent/topic/list';

    // Sent Subscriber
    static SentSubscriberList = '/sent/subscriber/list';
}